import { Box, Checkbox, FormControlLabel, TextField } from "@mui/material";
import {
  useCreateCustomerReferenceMutation,
  useUpdateCustomerReferenceMutation,
} from "app/api/orders";
import SimpleDialog from "components/SimpleDialog";
import { Contact } from "models/Contact";
import { useState } from "react";

type EditCustomerReferenceDialogProps = {
  orderId: string;
  isReference: boolean;
  contact: Contact | null;
  onClose: () => void;
};

const EditCustomerReferenceDialog: React.FC<EditCustomerReferenceDialogProps> = (props) => {
  const { orderId, isReference: initialIsReference, contact: initialContact, onClose } = props;

  const [includeContact, setIncludeContact] = useState(initialContact !== null);
  const [name, setName] = useState(initialContact?.name || "");
  const [email, setEmail] = useState(initialContact?.email || "");
  const [phone, setPhone] = useState(initialContact?.phone || "");
  const [createCustomerReference, { isLoading: isCreating }] = useCreateCustomerReferenceMutation();
  const [updateCustomerReference, { isLoading: isUpdating }] = useUpdateCustomerReferenceMutation();

  const submitCustomerReference = () => {
    const method = initialIsReference ? updateCustomerReference : createCustomerReference;
    method({
      orderId: orderId,
      contact: includeContact
        ? {
            name: name,
            email: email,
            phone: phone,
          }
        : null,
    }).then(() => onClose());
  };

  return (
    <SimpleDialog
      title="Referensobjekt"
      onClose={onClose}
      onSubmit={(e) => {
        e.preventDefault();
        submitCustomerReference();
      }}
      loading={isCreating || isUpdating}
    >
      <Box sx={{ display: "grid", gap: 1 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={includeContact}
              onChange={() => setIncludeContact(!includeContact)}
            />
          }
          label="Med kontaktperson"
          labelPlacement="end"
        />

        {includeContact && (
          <>
            <TextField
              variant="filled"
              fullWidth
              required
              label="Namn"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <TextField
              variant="filled"
              fullWidth
              required
              label="E-post"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              variant="filled"
              fullWidth
              required
              label="Telefon"
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </>
        )}
      </Box>
    </SimpleDialog>
  );
};

export default EditCustomerReferenceDialog;
